import { Box, Select, MenuItem, FormControl } from '@mui/material';
import Layout from '../layout';
import { useState } from 'react';
import Block from '../../../components/block';
import CategoryBar from '../../../components/chart/CategoryBar';
import TagBar from '../../../components/chart/TagBar';
import CategoryPie from '../../../components/chart/CategoryPie';
import TagPie from '../../../components/chart/TagPie';
import PeriodToggle, { PeriodType } from '../../../components/periodToggle';
import ChartTypeToggle from '../../../components/chartTypeToggle';

const filterOptions = [
  { label: 'Категории', value: 'category' },
  { label: 'Хештеги', value: 'tag' },
];

type ChartFilter = 'category' | 'tag';
type ChartType = 'bar' | 'pie';

type OperationsPageProps = {
  type: 'income' | 'expense';
};

const OperationsPage = ({ type }: OperationsPageProps) => {
  const [period, setPeriod] = useState<PeriodType>('year');
  const [chartFilter, setChartFilter] = useState<ChartFilter>('category');
  const [chartType, setChartType] = useState<ChartType>('bar');
  const [customRange, setCustomRange] = useState({
    from: '',
    to: '',
  });

  const handlePeriodChange = (newPeriod: PeriodType | null) => {
    if (newPeriod) setPeriod(newPeriod);
  };

  const handleChartChange = (newType: ChartType | null) => {
    if (newType) setChartType(newType);
  };

  return (
    <Layout>
      <h1 style={{ fontSize: '1rem', marginBottom: '1rem', color: '#666' }}>
        {type === 'income' ? 'Доходы' : 'Расходы'}
      </h1>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
          mb: 2,
          flexWrap: 'wrap',
        }}
      >
        <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <PeriodToggle
            value={period}
            onChange={handlePeriodChange}
            range={customRange}
            onRangeChange={setCustomRange}
          />
        </Box>
        <Box
          sx={{
            mt: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            flexWrap: 'wrap',
          }}
        >
          <ChartTypeToggle value={chartType} onChange={handleChartChange} />

          <FormControl size="small" sx={{ minWidth: 180 }}>
            <Select
              value={chartFilter}
              onChange={e => setChartFilter(e.target.value as ChartFilter)}
            >
              {filterOptions.map(opt => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>

      <Box>
        {chartFilter === 'category' && chartType === 'bar' && (
          <CategoryBar
            dataType={type}
            period={period}
            from={customRange.from}
            to={customRange.to}
          />
        )}
        {chartFilter === 'category' && chartType === 'pie' && (
          <CategoryPie
            dataType={type}
            period={period}
            from={customRange.from}
            to={customRange.to}
          />
        )}

        {chartFilter === 'tag' && chartType === 'bar' && (
          <TagBar dataType={type} period={period} from={customRange.from} to={customRange.to} />
        )}
        {chartFilter === 'tag' && chartType === 'pie' && (
          <TagPie dataType={type} period={period} from={customRange.from} to={customRange.to} />
        )}
      </Box>

      <Box sx={{ mt: 6, width: '100%' }}>
        <Block type={type} />
      </Box>
    </Layout>
  );
};

export default OperationsPage;
